import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    Form, FormBtn, FormCover,
    H1, H3,
    MediumSpacing
} from "../../styles";

const StudentEnrollmentCreate = () => {
    const navigate = useNavigate();
    const [students, setStudents] = useState([]);
    const [classes, setClasses] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [grade, setGrade] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        axios.get('/students/')
            .then(response => {
                setStudents(response.data);
            })
            .catch(error => console.error("There was an error fetching the students!", error));

        axios.get('/classes/')
            .then(response => {
                setClasses(response.data);
            })
            .catch(error => console.error("There was an error fetching the classes!", error));
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        setErrorMessage(''); // Clear any previous error message
        axios.post('/student_enrollment/', {
            student: selectedStudent,
            class_enrolled: selectedClass,
            grade: grade
        })
            .then(response => {
                navigate(`/class/${selectedClass}`);
            })
            .catch(error => {
                console.error("There was an error creating the enrollment!", error);
                if (error.response && error.response.data && error.response.data.detail) {
                    setErrorMessage(error.response.data.detail);
                } else {
                    setErrorMessage("There was an error creating the enrollment!");
                }
            });
    };

    return (
        <Container>
            <FormCover>
            <H3>Add Student Enrollment</H3>
            <MediumSpacing/>
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                <Form onSubmit={handleSubmit}>
                    <label>
                        Student:

                    </label>
                    <br/>
                    <select value={selectedStudent} onChange={(e) => setSelectedStudent(e.target.value)} required>
                        <option value="">Select a student</option>
                        {students.map(student => (
                            <option key={student.student_id} value={student.student_id}>
                                {student.first_name} {student.last_name}
                            </option>
                        ))}
                    </select>
                    <MediumSpacing/>
                    <label>
                        Class:

                    </label>
                    <br/>
                    <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)} required>
                        <option value="">Select a class</option>
                        {classes.map(classItem => (
                            <option key={classItem.id} value={classItem.id}>
                                {classItem.course_details.name} - {classItem.number}
                            </option>
                        ))}
                    </select>
                    <FormBtn type="submit">Add Enrollment</FormBtn>
                </Form>
            </FormCover>
        </Container>
    );
};

export default StudentEnrollmentCreate;
